/**
 * Gráfico de anillo de recuentos — bloque 1 (2026-09-18).
 *
 * Sólo reparte RECUENTOS (cuántos presupuestos hay en cada estado): nunca
 * importes, que la web no calcula. SVG propio, sin librería: son una docena de
 * líneas y no justifican una dependencia ni un paquete de 100 KB.
 *
 * Accesible: el SVG es decorativo y la leyenda, con el nombre y el número de
 * cada parte, es la información (el color no va solo, `OD-0017 D-04`).
 */

export type ParteAnillo = {
  readonly clave: string;
  readonly etiqueta: string;
  readonly valor: number;
};

const RADIO = 40;
const CIRCUNFERENCIA = 2 * Math.PI * RADIO;

export function Anillo({ partes, total, etiquetaTotal }: { partes: readonly ParteAnillo[]; total: number; etiquetaTotal: string }) {
  let acumulado = 0;
  const visibles = partes.filter((p) => p.valor > 0);
  return (
    <div className="anillo">
      <svg viewBox="0 0 100 100" className="anillo-grafico" aria-hidden="true" focusable="false">
        <circle className="anillo-fondo" cx="50" cy="50" r={RADIO} />
        {total > 0
          ? visibles.map((p) => {
              const largo = (p.valor / total) * CIRCUNFERENCIA;
              const circulo = (
                <circle
                  key={p.clave}
                  className={`anillo-parte anillo-${p.clave}`}
                  cx="50"
                  cy="50"
                  r={RADIO}
                  strokeDasharray={`${largo} ${CIRCUNFERENCIA - largo}`}
                  strokeDashoffset={-acumulado}
                />
              );
              acumulado += largo;
              return circulo;
            })
          : null}
        <text x="50" y="50" className="anillo-total" textAnchor="middle" dominantBaseline="central">
          {total}
        </text>
      </svg>
      <ul className="anillo-leyenda" aria-label={etiquetaTotal}>
        {partes.map((p) => (
          <li key={p.clave}>
            <span className={`anillo-marca anillo-marca-${p.clave}`} aria-hidden="true" />
            <span className="anillo-etiqueta">{p.etiqueta}</span>
            <span className="anillo-valor">{p.valor}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
